<template>
  <van-dialog
    v-model="show"
    class="dialog"
    show-cancel-button
    @close="confirm"
    @confirm="confirm"
  >
    <van-form style="position: relative; margin-top: 2rem; display: flex">
      <van-field v-model="formData.text" name="text" label="业务类型" />
      <van-button type="primary" @click="search">查询</van-button>
    </van-form>
    <van-list
      class="scrollList"
      :finished="finished"
      :loading-text="'加载中...'"
      :finished-text="'已显示全部'"
      @load="onLoad"
      v-model="loading"
      :error="error"
      :error-click="search"
    >
      <van-cell
        ref="cell"
        v-for="item in bizTypeList"
        :key="item.value"
        :title="item.text"
        @click="showActive(item)"
      />
    </van-list>
  </van-dialog>
</template>
<script>
import { PRODUCT_STOCK_BIZ_TYPE } from "../utils/constants";
// 导入样式

export default {
  name: "bizTypeSelect",
  components: {},
  props: {
    visible: false,
  },
  data() {
    return {
      error: false,
      loading: false,
      finished: true,
      show: false,
      formData: { text: "" },
      bizTypeList: [],
      allBizTypes: [],
      currentRow: {},
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.show = newVal;
      if (newVal) {
        this.loadAllBizTypes();
      }
    },
  },
  mounted() {
    this.loadAllBizTypes();
  },
  methods: {
    onLoad() {
      // 因为是静态数据，不需要分页加载
      this.finished = true;
      this.loading = false;
    },
    search() {
      const searchText = this.formData.text.toLowerCase();
      this.bizTypeList = this.allBizTypes.filter(item => 
        item.text.toLowerCase().includes(searchText)
      );
    },
    loadAllBizTypes() {
      // 直接使用导入的常量，不调用接口
      this.allBizTypes = PRODUCT_STOCK_BIZ_TYPE;
      this.bizTypeList = [...this.allBizTypes];
    },
    showActive(item) {
      this.currentRow = item;
      const exitIndex = this.bizTypeList.findIndex(i => i.value === item.value);
      this.$refs.cell.forEach((el, index) => {
        el.classList.remove("active");
        if (index == exitIndex) {
          el.classList.add("active");
        }
      });
    },
    confirm() {
      this.$emit("confirm", this.currentRow);
      this.show = false;
      this.currentRow = {};
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background: #1989fa;
}
.dialog {
  height: 80%;
}

::v-deep .van-dialog__content {
  height: 100%;

  // .van-form {
  //   height: 100%;
  // }
}

.scrollList {
  height: calc(100% - 115px) !important;

  overflow: auto;
}
::v-deep .van-dialog__footer {
  position: sticky;
  bottom: 0;
}
</style>